import React from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import Text from '../textStyleDefault/texto'

interface Props {
  color: string
  variant?: 'header' | 'footer' | 'menu'
  onClose?: () => void
}

const ServiciosDropdown = ({ color, variant = 'menu', onClose }: Props): JSX.Element => {
  const { t } = useTranslation()

  const handleNavClick = (to: string): void => {
    if (window.location.pathname === to) {
      // Scroll to the top of the page
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    // Close the dropdown
    onClose?.()
  }

  return (
    <ul
      className={clsx('font-normal cursor-pointer', {
        'w-max absolute p-[10px] text-left mt-[33.5px] rounded-[8px] border-white border-[1px] ml-[100%] space-y-[4px]': variant === 'header',
        'w-max text-[14px] space-y-[16px] text-left': variant === 'footer',
        'w-screen space-y-[4px] text-center mt-[0.5px]': variant === 'menu',
        'bg-[#043873]': color === 'white',
        'bg-white': color !== 'white'
      })}
    >
      {variant === 'menu' && <div className="border-t-[1px] border-white w-[340px] mx-auto"></div>}

      <li
        onClick={() => {
          handleNavClick('/consultoria/')
        }}
        className={clsx(
          '',
          variant === 'menu' && 'hover:bg-blue-500 p-[10px] hover:text-[#043873] items-center',
          variant === 'footer' && 'text-[16px] md:text-[20px]',
          variant === 'header' && '!mt-[-4px]'
        )}
      >
        <NavLink to="/consultoria/">
          <Text
            as="a"
            className={clsx(
              'font-[500] leading-[17.5px] tracking-[0.021px]',
              variant === 'menu' || variant === 'header' ? '!text-[12px]' : '!text-[14px]'
            )}
          >
            {t('Consultoria')}
          </Text>
        </NavLink>
      </li>
      <li
        onClick={() => {
          handleNavClick('/desarrollo-software/')
        }}
        className={clsx(
          '',
          variant === 'menu' && 'hover:bg-blue-500 p-[10px] hover:text-[#043873] items-center',
          variant === 'footer' && 'text-[16px] md:text-[20px]',
          variant === 'header' && '!mt-[-4px]'
        )}
      >
        <NavLink to="/desarrollo-software/">
          <Text
            as="a"
            className={clsx(
              'font-[500] leading-[17.5px] tracking-[0.021px]',
              variant === 'menu' || variant === 'header' ? '!text-[12px]' : '!text-[14px]'
            )}
          >
            {t('desarrollo de software')}
          </Text>
        </NavLink>
      </li>
      <li
        onClick={() => {
          handleNavClick('/gestion-de-productos/')
        }}
        className={clsx(
          '',
          variant === 'menu' && 'hover:bg-blue-500 p-[10px] hover:text-[#043873] items-center',
          variant === 'footer' && 'text-[16px] md:text-[20px]',
          variant === 'header' && '!mt-[-4px]'
        )}
      >
        <NavLink to="/gestion-de-productos/">
          <Text
            as="a"
            className={clsx(
              'font-[500] leading-[17.5px] tracking-[0.021px]',
              variant === 'menu' || variant === 'header' ? '!text-[12px]' : '!text-[14px]'
            )}
          >
            {t('Gestión de productos')}
          </Text>
        </NavLink>
      </li>
      <li
        onClick={() => {
          handleNavClick('/soporte-de-operaciones/')
        }}
        className={clsx(
          '',
          variant === 'menu' && 'hover:bg-blue-500 p-[10px] hover:text-[#043873] items-center',
          variant === 'footer' && 'text-[16px] md:text-[20px]',
          variant === 'header' && '!mt-[-4px]'
        )}
      >
        <NavLink to="/soporte-de-operaciones/">
          <Text
            as="a"
            className={clsx(
              'font-[500] leading-[17.5px] tracking-[0.021px]',
              variant === 'menu' || variant === 'header' ? '!text-[12px]' : '!text-[14px]'
            )}
          >
            {t('Soporte de operaciones')}
          </Text>
        </NavLink>
      </li>
      <li
        onClick={() => {
          handleNavClick('/arquitectura/')
        }}
        className={clsx(
          '',
          variant === 'menu' && 'hover:bg-blue-500 p-[10px] hover:text-[#043873] items-center',
          variant === 'footer' && 'text-[16px] md:text-[20px]',
          variant === 'header' && '!mt-[-4px]'
        )}
      >
        <NavLink to="/arquitectura/">
          <Text
            as="a"
            className={clsx(
              'font-[500] leading-[17.5px] tracking-[0.021px]',
              variant === 'menu' || variant === 'header' ? '!text-[12px]' : '!text-[14px]'
            )}
          >
            {t('Arquitectura de software')}
          </Text>
        </NavLink>
      </li>
      <li
        onClick={() => {
          handleNavClick('/estrategia-it/')
        }}
        className={clsx(
          '',
          variant === 'menu' && 'hover:bg-blue-500 p-[10px] hover:text-[#043873] items-center',
          variant === 'footer' && 'text-[16px] md:text-[20px]',
          variant === 'header' && '!mt-[-4px]'
        )}
      >
        <NavLink to="/estrategia-it/">
          <Text
            as="a"
            className={clsx(
              'font-[500] leading-[17.5px] tracking-[0.021px]',
              variant === 'menu' || variant === 'header' ? '!text-[12px]' : '!text-[14px]'
            )}
          >
            {t('Estrategía de TI')}
          </Text>
        </NavLink>
      </li>
    </ul>
  )
}

export default ServiciosDropdown
